import { render, staticRenderFns } from "./PublicCertificate.vue?vue&type=template&id=d8623ee2&scoped=true"
import script from "./PublicCertificate.vue?vue&type=script&lang=js"
export * from "./PublicCertificate.vue?vue&type=script&lang=js"
import style0 from "./PublicCertificate.vue?vue&type=style&index=0&id=d8623ee2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8623ee2",
  null
  
)

export default component.exports